namespace $.$$ {
	export class $shm_hitalama_map_widget_float_table_filter extends $.$shm_hitalama_map_widget_float_table_filter {
		changed() {}
		@ $mol_mem
		mode( next?: string ) { if( next !== undefined ) this.changed(); return next ?? 'all' }
		@ $mol_mem
		value( next?: string ) { if( next !== undefined ) this.changed(); return next ?? '' }
		@ $mol_mem
		until( next?: string ) { if( next !== undefined ) this.changed(); return next ?? '' }
		modes() {
			return {
				all: 'Без фильтра',
				...( this.kind() === 'file' ? {} : this.kind() === 'text'
					? { contains: 'Содержит', equals: 'Равно' }
					: { equals: 'Равно', range: 'В диапазоне', after: 'Не меньше / не раньше', before: 'Не больше / не позже' } ),
				filled: this.kind() === 'file' ? 'Есть файл' : 'Заполнено',
				empty: this.kind() === 'file' ? 'Нет файла' : 'Не заполнено',
			}
		}
		inputs() {
			if( [ 'all', 'filled', 'empty' ].includes( this.mode() ) ) return []
			return this.mode() === 'range' ? [ this.Value(), this.Until() ] : [ this.Value() ]
		}
		value_hint() { return this.kind() === 'date' ? 'дд.мм.гггг' : this.kind() === 'number' ? 'Число' : 'Текст' }
		until_hint() { return this.kind() === 'date' ? 'До дд.мм.гггг включительно' : 'До включительно' }
		parse( value: unknown ): string | number {
			const text = String( value ?? '' ).trim()
			if( this.kind() === 'number' ) return text ? Number( text.replace( /\s/g, '' ).replace( ',', '.' ) ) : NaN
			if( this.kind() !== 'date' ) return text.toLocaleLowerCase( 'ru' )
			const ru = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec( text )
			const iso = /^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/.exec( text )
			if( !ru && !iso ) return NaN
			const [ y, m, d ] = ru ? [ +ru[3], +ru[2], +ru[1] ] : [ +iso![1], +iso![2], +iso![3] ]
			const date = new Date( Date.UTC( y, m - 1, d ) )
			return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d ? date.getTime() : NaN
		}
		error() {
			if( !this.inputs().length || this.kind() === 'text' ) return ''
			const values = this.mode() === 'range' ? [ this.value(), this.until() ] : [ this.value() ]
			if( values.some( value => !value.trim() || Number.isNaN( this.parse( value ) ) ) ) {
				return this.kind() === 'date' ? 'Введите существующую дату в формате дд.мм.гггг' : 'Введите число'
			}
			return this.mode() === 'range' && this.parse( this.value() ) > this.parse( this.until() ) ? 'Начало диапазона больше конца' : ''
		}
		matches( raw: unknown ) {
			const mode = this.mode()
			if( mode === 'all' ) return true
			const filled = raw != null && String( raw ).trim() !== ''
			if( mode === 'filled' ) return filled
			if( mode === 'empty' ) return !filled
			if( this.error() || !filled ) return false
			const value = this.parse( raw ), from = this.parse( this.value() )
			if( mode === 'contains' ) return String( value ).includes( String( from ) )
			if( mode === 'equals' ) return value === from
			if( mode === 'after' ) return value >= from
			if( mode === 'before' ) return value <= from
			return value >= from && value <= this.parse( this.until() )
		}
	}
}
